<template>
  <div class="stories-page">
    <Hero 
      title="Stories" 
      subtitle="Read personal journeys and transformative experiences in China"
      :imageUrl="heroImage" 
      height="50vh"
    />
    <section class="articles-section section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">Personal Journeys</h2>
          <p class="section-description">
            Dive into authentic stories of discovery, cultural exchange, and personal transformation in China.
          </p>
        </div>
        <div class="articles-grid">
          <ArticleCard
            v-for="article in articles"
            :key="article.id"
            :article="article"
            :section="'stories'"
          />
        </div>
        <div v-if="articles.length === 0" class="no-articles">
          <div class="no-articles-content">
            <svg class="no-articles-icon" viewBox="0 0 24 24" fill="none">
              <path d="M12 6.253V10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 11.6691 13.9052 11.3604 13.7392 11.0963L18.2471 6.58845C19.5433 8.05321 20.4996 9.94915 20.9017 12.0667C21.0323 12.6953 21.639 13.1028 22.2676 12.9722C22.8962 12.8416 23.3037 12.2349 23.1731 11.6063C22.6438 8.84158 21.3799 6.32656 19.5533 4.28288C17.7267 2.23919 15.4139 0.751773 12.8355 0.00289855C12.2897 -0.140298 11.7103 -0.140298 11.1645 0.00289855C8.58611 0.751773 6.27331 2.23919 4.44671 4.28288C2.62012 6.32656 1.35622 8.84158 0.826941 11.6063C0.696266 12.2349 1.10378 12.8416 1.73239 12.9722C2.36101 13.1028 2.96771 12.6953 3.09838 12.0667C3.50044 9.94915 4.45673 8.05321 5.75294 6.58845L10.2608 11.0963C10.0948 11.3604 10 11.6691 10 12Z" fill="currentColor"/>
            </svg>
            <h3>No stories yet</h3>
            <p>Check back soon for inspiring personal journeys and experiences.</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import heroImage from '@/assets/images/stories-hero.jpg';
import Hero from '@/components/Hero.vue';
import ArticleCard from '@/components/ArticleCard.vue';
import articles from '@/content/stories/articles.js';

export default {
  name: 'Stories',
  components: {
    Hero,
    ArticleCard,
  },
  data() {
    return {
      articles,
      heroImage,
    };
  },
};
</script>

<style scoped>
.section-header {
  text-align: center;
  margin-bottom: var(--space-12);
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.section-title {
  font-family: var(--font-display);
  font-size: var(--text-4xl);
  font-weight: 600;
  color: var(--neutral-900);
  margin-bottom: var(--space-4);
  line-height: var(--leading-tight);
}

.section-description {
  font-size: var(--text-lg);
  color: var(--neutral-600);
  line-height: var(--leading-relaxed);
}

.articles-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: var(--space-8);
  margin-bottom: var(--space-12);
}

.no-articles {
  text-align: center;
  padding: var(--space-20) var(--space-4);
}

.no-articles-content {
  max-width: 400px;
  margin: 0 auto;
}

.no-articles-icon {
  width: 64px;
  height: 64px;
  color: var(--neutral-400);
  margin-bottom: var(--space-6);
}

.no-articles h3 {
  font-family: var(--font-display);
  font-size: var(--text-2xl);
  color: var(--neutral-700);
  margin-bottom: var(--space-3);
}

.no-articles p {
  color: var(--neutral-500);
  font-size: var(--text-base);
}

/* Responsive Design */
@media (max-width: 1200px) {
  .articles-grid {
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: var(--space-6);
  }
}

@media (max-width: 768px) {
  .articles-grid {
    grid-template-columns: 1fr;
    gap: var(--space-6);
  }
  
  .section-title {
    font-size: var(--text-3xl);
  }
  
  .section-description {
    font-size: var(--text-base);
  }
  
  .no-articles {
    padding: var(--space-16) var(--space-4);
  }
}

@media (max-width: 480px) {
  .section-header {
    margin-bottom: var(--space-8);
  }
  
  .section-title {
    font-size: var(--text-2xl);
  }
  
  .section-description {
    font-size: var(--text-sm);
  }
  
  .articles-grid {
    gap: var(--space-4);
  }
}
</style>